import { defineModel } from "../define-model";

export type EntityRef = { model: string; id: string; label?: string; path?: string };

export type AssistantToolCall = {
	id: string;
	workspaceId: string;
	threadId: string;
	messageId: string;
	projectId: string | null;
	toolCallId: string;
	name: string;
	arguments: Record<string, unknown>;
	result: Record<string, unknown> | null;
	status: "proposed" | "approved" | "rejected" | "running" | "succeeded" | "failed";
	requiresApproval: boolean;
	estimatedMillicredits: number;
	entityRefs: EntityRef[];
	error: string | null;
	agentRunId: string | null;
	actorType: "user" | "agent";
	/** Proposed by an agent for a human to accept, rather than requested in chat. */
	suggestion: boolean;
	startedAt: string | null;
	finishedAt: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		assistantToolCall: AssistantToolCall;
	}
}

export const model = defineModel({
	name: "assistantToolCall",
	load: "lazy",
	indexes: ["messageId", "threadId"],
	sort: (a, b) => a.createdAt.localeCompare(b.createdAt) || a.id.localeCompare(b.id),
});
